import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";
import { getTours } from "../Api/TourApi";
import { CATEGORIES, SITE_NAME } from "../seo/site";
import { cld, normalizeTours, tourGroupKeys } from "../seo/tourSeo";

const LOGO = cld("c_fit,w_374,h_132/f_auto,q_auto", "img/logo-color-big");

const LINKS = [
  ["/gift-certificates", "Gift Cards"],
  ["/event-calendar", "Calendar"],
  ["/private-tours", "Private Tours"],
  ["/faq", "FAQ"],
  ["/contact-us", "Contact Us"],
];

const ABOUT = [
  ["/about-us", "Our Story"],
  ["/featured", "Featured In"],
  ["/friends", "Our Friends"],
  ["/hiring", "Now Hiring"],
];

const TopNav = () => {
  const [tours, setTours] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    getTours()
      .then((rows) => {
        if (!cancelled) setTours(normalizeTours(rows));
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  // Close the mobile menu after navigating.
  useEffect(() => {
    setExpanded(false);
  }, [pathname]);

  const isTourPage = tours.some((t) => pathname === `/${t.pathTitle}` || pathname.startsWith(`/${t.pathTitle}/`));

  return (
    <>
      <a href="#main" className="skip-link">Skip to main content</a>
      <Navbar bg="light" expand="lg" fixed="top" expanded={expanded} onToggle={setExpanded} className="site-nav">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img src={LOGO} width="187" height="66" alt={`${SITE_NAME} home`} fetchpriority="high" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="site-nav-collapse" aria-label="Toggle navigation" />

          <Navbar.Collapse id="site-nav-collapse">
            <Nav className="m-auto">
              <NavDropdown title="Tours" id="nav-tours" className={`site-nav__mega${isTourPage ? " active" : ""}`}>
                <div className="mega-menu">
                  {CATEGORIES.map((category) => {
                    const inGroup = tours.filter((t) => tourGroupKeys(t).includes(category.key));
                    if (!inGroup.length) return null;
                    return (
                      <div className="mega-menu__col" key={category.key}>
                        <div className="mega-menu__heading">{category.label}</div>
                        {inGroup.map((t) => (
                          <NavDropdown.Item as={Link} to={`/${t.pathTitle}`} key={t.pathTitle} active={pathname === `/${t.pathTitle}`}>
                            {t.title}
                          </NavDropdown.Item>
                        ))}
                      </div>
                    );
                  })}
                </div>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/" className="dropdown-item--all">
                  See all tours
                </NavDropdown.Item>
              </NavDropdown>

              {LINKS.map(([to, label]) => (
                <Nav.Link as={NavLink} to={to} key={to}>
                  {label}
                </Nav.Link>
              ))}

              <NavDropdown title="About Us" id="nav-about" alignRight className={ABOUT.some(([to]) => pathname === to) ? "active" : ""}>
                {ABOUT.map(([to, label]) => (
                  <NavDropdown.Item as={Link} to={to} key={to} active={pathname === to}>
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default TopNav;
